/* import __COLOCATED_TEMPLATE__ from './hamburger-button.hbs'; */
import {
  attributeBindings,
  classNameBindings,
  classNames,
  tagName,
} from '@ember-decorators/component';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './hamburger-button.module.scss';

@attributeBindings('ariaExpanded:aria-expanded', 'type')
@classNameBindings('isOpen:open')
@tagName('button')
@classic
@classNames(styles.component)
export default class SharedHamburgerButton extends Component {
  @service intl;

  type = 'button';

  get openedMessage() {
    return this.intl.t('shared.navigation.closeMenu');
  }

  get closedMessage() {
    return this.intl.t('shared.navigation.openMenu');
  }

  @computed('isOpen')
  get ariaExpanded() {
    return this.isOpen ? 'true' : 'false';
  }

  click() {
    this.onClick();
  }

  onClick() {
    this.toggleProperty('isOpen');
  }
}
